import { useAuthStore } from '@turfchale/supabase'
import posthog from 'posthog-js'
import { useEffect } from 'react'

export function useIdentify() {
  const user = useAuthStore((s) => s.user)
  const profile = useAuthStore((s) => s.profile)

  useEffect(() => {
    if (!user) {
      posthog.reset()
      return
    }

    posthog.identify(user.id, {
      email: user.email,
      ...(profile?.role ? { role: profile.role } : {}),
    })
  }, [user, profile])
}
